import * as types from "./userRole.actionTypes";
import { UserAccess } from "../../interfaces/UserAccess";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { PermissionDefault, PermissionMenuName, UserRole } from "../../interfaces/UserRole";
import { UserRoleCreateResponse, UserRoleDetailResponse, UserRoleListResponse, UserRoleSaveResponse } from "./types";

const defaultPermissions = [...PermissionDefault]

export const initializeCreateRole = () => {
  return action(types.INITIALIZE_CREATE_ROLE, { permissions: [
    {
      MENU_NAME: PermissionMenuName.dokumenKerjasama,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    },
    {
      MENU_NAME: PermissionMenuName.monevPartner,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    },
    {
      MENU_NAME: PermissionMenuName.partner,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    },
    {
      MENU_NAME: PermissionMenuName.masterData,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    },
    {
      MENU_NAME: PermissionMenuName.userControl,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    },
    {
      MENU_NAME: PermissionMenuName.userRole,
      ACCESS: {
        create: false,
        read: false,
        x: false,
        update: false,
        delete: false
      }
    }
  ] })
}

export const selectRole = (role: UserRole | null) => {
  const permissions = [...defaultPermissions];
  const mutableRole: UserRole | null = role ? {...role} : null;

  if (mutableRole) {
    mutableRole.PERMISSION_DETAIL.forEach(item => {
      const permissionIndex = permissions.findIndex(searchItem => searchItem.MENU_NAME === item.MENU_NAME);
      if (permissionIndex >= 0) {
        permissions[permissionIndex] = item;
      }
      
    });
    mutableRole.PERMISSION_DETAIL = permissions;
  }

  return action(types.SELECT_ROLE, { role: mutableRole });
}

export const updateName = (name: string) => action(types.UPDATE_NAME, { name });
export const updateStatus = (value: number) => action(types.UPDATE_STATUS, { value });

export const updatePermissions = (permissions: UserAccess[]) => action(types.UPDATE_PERMISSIONS, { permissions });

export const getRoleAsync = createAsyncAction(
  types.GET_ROLE_REQUEST,
  types.GET_ROLE_SUCCESS,
  types.GET_ROLE_FAILURE
)<undefined, UserRoleListResponse, ErrorResponse>();

export const getDetailRoleAsync = createAsyncAction(
  types.GET_DETAIL_ROLE_REQUEST,
  types.GET_DETAIL_ROLE_SUCCESS,
  types.GET_DETAIL_ROLE_FAILURE
)<{ id: number }, UserRoleDetailResponse, ErrorResponse>();

export const saveRoleAsync = createAsyncAction(
  types.SAVE_ROLE_REQUEST,
  types.SAVE_ROLE_SUCCESS,
  types.SAVE_ROLE_FAILURE
)<UserRole, UserRoleSaveResponse, ErrorResponse>();

export const createRoleAsync = createAsyncAction(
  types.CREATE_ROLE_REQUEST,
  types.CREATE_ROLE_SUCCESS,
  types.CREATE_ROLE_FAILURE
)<UserRole, UserRoleCreateResponse, ErrorResponse>();
